export const apiResponseHandler = (error) => {
  if (error.response && error.response.data) {
    // eslint-disable-next-line
    throw {...error.response.data, status: error.response.status};
  } else {
    throw error;
  }
};
